import { FR, EN } from './constants';

export function getLangs() {
  return [FR, EN];
}
